export * from './ticket-get-status/ticket-get-status.component';
export * from './info/privacy-default.component';
